import LegalPage from '@/components/legal/LegalPage';

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      intro="How Quick Credit collects, uses, shares and protects your personal information."
      sections={[
        {
          heading: 'Information we collect',
          body: (
            <p>
              We collect information you provide when you check your rate or apply for a loan — including
              your name, contact details, address, date of birth, employment and income details, and bank
              account information. We also collect technical data such as your IP address, device type and
              how you use our website.
            </p>
          ),
        },
        {
          heading: 'How we use your information',
          body: (
            <p>
              We use your information to verify your identity, assess your creditworthiness and
              affordability, prevent fraud and money laundering, service your loan, and meet our legal and
              regulatory obligations. We may also use it to contact you about your application or account.
            </p>
          ),
        },
        {
          heading: 'Credit checks',
          body: (
            <p>
              Checking your rate uses a soft credit inquiry, which does not affect your credit score. If you
              proceed with a full application, we may perform a hard credit inquiry, which is recorded on
              your credit file and may affect your score.
            </p>
          ),
        },
        {
          heading: 'Who we share it with',
          body: (
            <p>
              We share information with credit reference and fraud prevention agencies, identity and income
              verification providers, payment processors, and our technology service providers, all under
              contract. We share data with regulators or law enforcement where legally required. We do not
              sell your personal information.
            </p>
          ),
        },
        {
          heading: 'How long we keep it',
          body: (
            <p>
              We retain application and account records for as long as needed to service your loan and for
              the period required by applicable law and regulation, typically at least seven years after
              your relationship with us ends.
            </p>
          ),
        },
        {
          heading: 'Your rights',
          body: (
            <p>
              You may request access to the personal information we hold about you, ask us to correct
              inaccuracies, request deletion where the law allows, object to certain processing, and opt out
              of marketing communications at any time. Contact us using the details below to exercise these
              rights.
            </p>
          ),
        },
        {
          heading: 'Security',
          body: (
            <p>
              Data is transmitted over encrypted HTTPS connections and stored encrypted at rest with strict
              access controls, monitoring and regular security reviews.
            </p>
          ),
        },
      ]}
    />
  );
}
